// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"main_wrapper__RilK6"};